import { createFileRoute } from '@tanstack/react-router'

import { ReviewTasksListPage } from '../../../components/pages/backoffice/review-tasks/review-tasks-list-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/review-tasks/')({
  component: () => (
    <PermissionChecker requiredPermissions={['reviewTasks.read']}>
      <ReviewTasksListPage />
    </PermissionChecker>
  ),
})
